module.exports = __webpack_public_path__ + "static/media/logo-icon.113d1559.png";